module.exports = __webpack_public_path__ + "img/bigGz.9391d77b.png";